/*
* Component for a button which sits on an organisation page that allows the user to follow an organisation.
*/
<template>
  <button :class="classes" @click.prevent="doClick" title="Add to Compare" aria-label="Add to Compare">
    <span>{{ title }}</span>
  </button>
</template>

<script>
  export default {
    name: 'Compare',

   	props: {
			title: {
				type: String,
        default: 'Compare'
			},
      org_slug: {
				type: String
			}
		},

   	data() {
      return {

      }
    },

    methods: {
      doClick() {
				this.emitter.emit("openModal",{'name':'OrgCompare', 'additional':this.org_slug, persistent: true});
	    }

    },

    computed: {
      classes() {
        return {
          'btn': true,
          'btn-blue-light': false,
          'btn-rounded': true,
          'btn-medium': true
        }
      },
    },
    watch: {

    }
  };
</script>
